<template>
    <div class="animated fadeIn">
        <b-row>
            <b-col lg="12">
                <b-card>
                    <div slot="header">
                        <strong>Tra cứu, tìm kiếm loại lý do biến động</strong>
                    </div>
                    <b-form @submit.prevent="search">
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Phần mềm đồng bộ:"
                                              label-for="input-string"
                                              label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <div class="col-md-6 no-padding">
                                        <sync-data-source v-model="searchForm.syncSourceType" :excluded="[2]"
                                                          :cached="true"
                                                          allowClear="true">
                                        </sync-data-source>
                                    </div>
                                </b-form-group>
                            </b-col>
                        </b-row>
                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="Mã/Tên loại lý do biến động:"
                                              label-for="input-string"
                                              label-cols-md="3"
                                              :horizontal="true"
                                              label-align="left">
                                    <b-form-input id="input-string" class="col-md-6"
                                                  v-model="searchForm.str"
                                                  type="text"
                                                  placeholder="Nhập tên hoặc mã loại lý do biến động...">
                                    </b-form-input>
                                </b-form-group>
                            </b-col>
                        </b-row>

                        <b-row>
                            <b-col offset-md="2">
                                <b-form-group label="" :label-cols="4" label-cols-md="3">
                                    <b-button type="submit" variant="primary">Tìm kiếm</b-button>
                                </b-form-group>
                            </b-col>
                        </b-row>
                    </b-form>
                    <b-grid :searchForm="searchForm"
                            :gridOptions="gridOptions"
                            dataUrl="master-data/asset-mutation-cause-types"
                            gridName="Danh sách loại lý do biến động"
                            ref="assetMutationCauseTypeTable">
                        <template v-slot:actions v-if="authorize(['ManageAssetMutationCauseType']) && isBTCUser">
                            <router-link to="./create" tag="button" class="btn btn-primary" size="md">
                                Thêm mới
                            </router-link>
                            <!--<b-button size="md" @click.stop="deletes" variant="danger" :disabled="isShowBtnDelete">
                                Xóa
                            </b-button>-->
                        </template>
                        <template v-slot:cell(assetTypeName)="row">
                            {{ $store.getters.getAssetTypePath(row.item.assetTypeId) || row.item.assetTypeName }}
                        </template>
                        <template v-slot:cell(syncSourceType)="row">
                            {{ $store.getters.getSyncSourceType(row.value) }}
                        </template>
                        <template v-slot:cell(_actions)="row">
                            <b-button-group>
                                <template v-if="authorize(['ViewAssetMutationCauseType'])">
                                    <b-button size="sm" :to="{ path: `./${row.item.id}`}" title="xem" variant="info">
                                        Xem
                                    </b-button>
                                </template>
                                <template v-if="authorize(['ManageAssetMutationCauseType']) && isBTCUser">
                                    <b-button size="sm" :to="{ path: `./${row.item.id}/edit` }" title="sửa" variant="primary">
                                        Sửa
                                    </b-button>
                                    <b-button size="sm" @click.stop="remove(row.item, row.index, $event.target)" class="mr-1" title="xóa" variant="danger">
                                        Xoá
                                    </b-button>
                                </template>
                            </b-button-group>
                        </template>
                    </b-grid>
                </b-card>
            </b-col>
        </b-row>
    </div>
</template>
<script>
    import { mixins } from '@/shared/mixins'

    export default {
        name: 'ListAssetMutationCauseType',
        mixins: [mixins],
        data() {
            return {
                searchForm: {
                    str: null,
                    syncSourceType: this.getSyncSourceTypeCache(null, [2]),
                },
                gridOptions: {
                    fields: [
                        { key: 'code', label: 'Mã loại lý do biến động', sortable: true, sortDirection: 'asc' },
                        { key: 'name', label: 'Tên loại lý do biến động', sortable: true },
                        { key: 'syncSourceType', label: 'Phần mềm đồng bộ', sortable: true },
                        { key: 'displayOrder', label: 'Thứ tự hiển thị', sortable: true }
                    ],
                    sortBy: 'displayOrder'
                },
                isShowBtnDelete: true
            }
        },
        created() {
        },
        mounted() {
            this.$watch(
                () => {
                    return this.$refs.assetMutationCauseTypeTable.selectedRows
                },
                (val) => {
                    this.isShowBtnDelete = val.length == 0;
                }
            )
        },
        methods: {
            search() {
                this.$refs.assetMutationCauseTypeTable.refresh();
            },
            remove(item, index, button) {
                var vm = this;

                if (confirm('Bạn có chắc chắn muốn xóa loại lý do biến động này?')) {
                    this.$services.delete(`master-data/asset-mutation-cause-types/${item.id}`).done(() => {
                        vm.$toastr.s('Xóa lý do giảm thành công');
                        vm.$store.dispatch('loadAssetMutationCauseTypes');
                        vm.search();
                    });
                }
            },
            deletes() {
                var vm = this;
                var selectedRows = this.$refs.assetMutationCauseTypeTable.selectedRows;
                if (selectedRows.length > 0) {
                    if (confirm('Bạn có chắc chắn muốn xóa các loại lý do biến động này?')) {
                        var data = selectedRows.map(x => x.id).join(',');
                        this.$services.delete(`master-data/asset-mutation-cause-types?ids=${data}`).done(() => {
                            vm.$toastr.s('Xóa lý do giảm thành công');
                            vm.$store.dispatch('loadAssetMutationCauseTypes');
                            vm.search();
                        });
                    }
                }
                else {
                    vm.$toastr.e('Vui lòng chọn loại lý do biến động cần xóa');
                }
            }
        }
    }
</script>
<style scoped>
</style>
